module.exports = __webpack_public_path__ + "img/left_worm_n2_1.prt.c9b214ee.jpg";